"use client";

import React from "react";
import { Car, MapPin, TrainFront } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const locationData = {
  address: "Stau 123, 26125 Oldenburg",
  mapUrl: "https://maps.google.com/maps?q=Stau%20123%2C%2026125%20Oldenburg&t=&z=15&ie=UTF8&iwloc=&output=embed"
};
const infoCards = [{
  title: "Sicherer Zugang",
  description: "Unser Security Operations Center verfügt über gesicherte Besucherparkplätze direkt am Hauptgebäude. Einlass erfolgt nach vorheriger digitaler Anmeldung.",
  icon: Car
}, {
  title: "Infrastruktur-Anbindung",
  description: "Zentral gelegen am Oldenburg Hafen. Exzellente Anbindung an den ÖPNV über den Hauptbahnhof, nur wenige Gehminuten von unserem Standort entfernt.",
  icon: TrainFront
}, {
  title: "Technologie-Hub",
  description: "Eingebettet in das Herz der deutschen IT-Sicherheitslandschaft. Unsere Kompletter Technologie-Hub befindet sich in zwei von einander getrennten Rechenzentren innerhalb Deutschland.",
  icon: MapPin
}];
export default function DoveTrovarci() {
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223399" id="unser-hauptquartier" className="w-full bg-background text-foreground flex flex-col">
      {}
      <div className="w-full h-[400px] md:h-[500px] lg:h-[600px] relative bg-muted border-b border-border">
        <iframe title="Mappa della posizione del ristorante CUCINA" src={locationData.mapUrl} className="w-full h-full border-0 grayscale contrast-150 opacity-80 dark:opacity-60 dark:invert dark:hue-rotate-180" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        {}
        <div className="absolute inset-0 pointer-events-none bg-primary/5 dark:bg-primary/10 mix-blend-overlay backdrop-blur-[1px]" />
      </div>

      {}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-4 tracking-tight">
            Unser Hauptquartier
          </h2>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl mx-auto">
            Besuchen Sie das SecureNetics SOC. Wir empfangen Sie in einer hochmodernen Umgebung, um Ihre digitale Verteidigungsstrategie persönlich zu besprechen.
          </p>
        </div>

        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-1000 ease-out ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {infoCards.map((card, index) => {
          const Icon = card.icon;
          return <Card key={index} data-index={index} className="bg-card border-border shadow-lg hover:shadow-primary/10 transition-all duration-300 h-full flex flex-col backdrop-blur-md">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center mb-4 border border-primary/20">
                    <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-default text-xl md:text-2xl text-card-foreground tracking-tight">
                    {card.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 flex-grow">
                  <p className="text-muted-foreground font-sans leading-relaxed">
                    {card.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}